<template>
  <div class="join_list_wrapper wrapper background">
    <ul class="join_list_inner">
      <li v-for="(participant, id) in participants" :key="id" @mouseover="mouseOverAction(participant.id)" @mouseleave="mouseLeaveAction">
        <transition name="fade" v-if="targetId === participant.id">
          <div class="mouseOver-content">
            <span>{{ participant.organization }}</span>
            <span>{{ participant.name }}</span>
          </div>
        </transition>
        <img :class="{isAdmin: participant.isAdmin()}" :src="participant.avatar" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Participants",
  props: {
    participants: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      targetId: null,
      accountType: {
        admin: 1,
        gPlus: 2,
        guest: 3
      },
      participantNameViewableType: {
        all: 1,
        employeeOnly: 2,
        hidden: 3
      }
    }
  },
  computed: {
    event() {
      return this.$store.getters["event/event"]
    },
    user() {
      return this.$store.getters["auth/user"]
    }
  },
  methods: {
    mouseOverAction(userId) {
      // イベント参加者のアイコンホバー時に名前を表示する
      switch (this.event.participant_name_viewable_type) {
        case this.participantNameViewableType.all:
          // 全員の名前を表示する場合
          this.targetId = userId
          break
        case this.participantNameViewableType.employeeOnly:
          // 社員からのみ名前表示する場合。 追加でログインユーザーが管理者か判定
          if (this.user.type === this.accountType.admin) {
            this.targetId = userId
            break
          }

          this.targetId = null
          break
        case this.participantNameViewableType.hidden:
          // 表示をしない場合
          this.targetId = null
          break
        default:
          this.targetId = null
      }
    },
    mouseLeaveAction() {
      this.targetId = null
    }
  }
}
</script>
